'use client'

import { createContext, useContext } from 'react'

import { Features } from './feature-manager'

const FeatureFlagContext = createContext<Features>([])

export function FeatureFlagProvider({
  features,
  children,
}: React.PropsWithChildren<{ features: Features }>) {
  return (
    <FeatureFlagContext.Provider value={features}>
      {children}
    </FeatureFlagContext.Provider>
  )
}

export function useFeatureFlag(flagName: string) {
  return useContext(FeatureFlagContext).some(
    ({ name, enabled }) => name === flagName && enabled,
  )
}
